import { LabelValueRow, LinkButton } from 'components/core-v2'
import Icon from 'components/core-v2/atoms/Icon'
import React from 'react'
import { formatCurrencyFull } from 'utilities/currency'
import { formatUnits } from 'utilities/number'

import { CURRENCY } from '../../../const'
import { ConfirmedOrder, isBuyOrder } from '../orders-detail/orders-types'
import classes from './order-corrected.module.scss'

interface OrderCorrectPriceProps {
  showModal: () => void
}

export const OrderCorrectPrice = ({ showModal }: OrderCorrectPriceProps) => (
  <div className={classes.link}>
    <Icon name="squareInput" size="default" />
    <LinkButton underline onClick={() => showModal()}>
      Correct the price
    </LinkButton>
  </div>
)

interface OrderCorrectedProps {
  order: ConfirmedOrder
}

const getPrice = (order: ConfirmedOrder) => ({
  price: order.correction.executionPrice,
  priceDifference: order.correction.executionPrice - order.executionPrice
})

const getValuesForBuyOrder = (order: ConfirmedOrder) => {
  const { correction, executionPrice, value } = order
  return {
    ...getPrice(order),
    units: value / (executionPrice / 100) + correction.sharesToBeAllocated,
    unitsDifference: correction.sharesToBeAllocated,
    total: value,
    totalDifference: undefined
  }
}

const getValuesForSellOrder = (order: ConfirmedOrder) => {
  const { correction, executionPrice, shares } = order
  return {
    ...getPrice(order),
    units: Math.abs(order.shares),
    unitsDifference: undefined,
    total: Math.abs(shares * (executionPrice / 100)) + correction.amountToBeAllocated,
    totalDifference: correction.amountToBeAllocated
  }
}

export const OrderCorrected = ({ order }: OrderCorrectedProps) => {
  const isBuy = isBuyOrder(order)
  const { price, priceDifference, total, units, ...data } = isBuy
    ? getValuesForBuyOrder(order)
    : getValuesForSellOrder(order)
  return (
    <>
      <LabelValueRow
        className={classes.firstRow}
        label="Price corrected"
        value={new Date(order.correction.createdTime).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })}
      />
      <LabelValueRow label="Corrected by" value={order.correction.correctionAuthor} />
      <LabelValueRow label="Number of units" value={formatUnits(units)} />
      {isBuy && (
        <LabelValueRow
          label="Number of units difference"
          value={formatUnits(data.unitsDifference)}
        />
      )}
      <LabelValueRow
        label="Price per unit"
        value={formatCurrencyFull(price, CURRENCY, null, true)}
      />
      <LabelValueRow
        label="Price per unit difference"
        value={formatCurrencyFull(priceDifference, CURRENCY, null, true)}
      />
      <LabelValueRow label="Total amount" value={formatCurrencyFull(total, CURRENCY)} />
      {!isBuy && (
        <LabelValueRow
          label="Total amount difference"
          value={formatCurrencyFull(data.totalDifference, CURRENCY)}
        />
      )}
    </>
  )
}
